import { IClientValidator } from "./IClientValidator";

/// Works with SummariseAdyenErrorsAttribute.cs to generate an error for the validation summary element when the Adyen details are not correct.

/// Used by the checkout/payment page.
export class SummariseAdyenErrors implements IClientValidator {
    public validate(value: string, element: HTMLInputElement, params: any): boolean {
        if (!element.checked) { // Checkbox for Adyen credit card selected.
            return true; // Not a card payment, all Adyen fields pass validation.
        }

        return window.paymentPage.adyenCardFieldsValid();
    }
}


window.validators = window.validators || {};
window.validators.summariseadyenerrors = new SummariseAdyenErrors();
